import React from "react"
import {Badge} from "@chakra-ui/react"

import {GamePlayStatus, gamePlayStatusEnum} from "../constants"

type GameStatusBadgeProps = {
    status: GamePlayStatus
}

export function GamePlayStatusBadge({status}: GameStatusBadgeProps) {

    return <Badge
        colorScheme={gamePlayStatusEnum[status].color}>{gamePlayStatusEnum[status].title}</Badge>
}